export default "__VITE_ASSET__f801d969__"